
import {
  defineComponent, computed, PropType, Ref, ref, nextTick,
} from 'vue';
import Button from 'primevue/button';
import Menu from 'primevue/menu';
import Tooltip from 'primevue/tooltip';
import { ToolbarItemsModel } from '@/types';
import CustomDatePicker from '@/components/fields/CustomDatePicker.vue';

export default defineComponent({
  name: 'ToolbarButtons',

  components: {
    CustomDatePicker,
    Button,
    Menu,
  },

  directives: {
    tooltip: Tooltip,
  },

  props: {
    buttons: {
      type: Array as PropType<ToolbarItemsModel[]>,
      required: false,
      default: () => [],
    },

    noShrink: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props: { buttons: ToolbarItemsModel[] }) {
    const menuRefs: Ref<any []> = ref([]);
    const loadingButton = ref(false);

    const toggleMenu = (event: Event, index: string) => {
      if (menuRefs.value) {
        menuRefs.value[index as keyof object].toggle(event);
      }
    };

    // Fonction pour supprimer le focus automatique du premier élément
    const handleMenuShow = () => {
      // Utiliser nextTick pour s'assurer que le DOM est mis à jour
      nextTick(() => {
        // Trouver tous les premiers éléments de menu avec la classe p-focus
        const focusedFirstItems = document.querySelectorAll('.toolbarbuttons-submenu .p-menuitem:first-child.p-focus');

        focusedFirstItems.forEach((item) => {
          // Supprimer la classe p-focus
          item.classList.remove('p-focus');

          // Supprimer aussi le focus du lien à l'intérieur
          const link = item.querySelector('.p-menuitem-link');
          if (link) {
            (link as HTMLElement).blur();
          }
        });
      });
    };

    const menuButtons = computed(() => props.buttons.filter((button: ToolbarItemsModel) => !button.hide));

    const handleCommand = async (btn: any) => {
      loadingButton.value = true;
      if (btn.command) {
        await btn.command();
      }
      loadingButton.value = false;
    };

    return {
      menuRefs,
      menuButtons,
      loadingButton,
      toggleMenu,
      handleCommand,
      handleMenuShow,
    };
  },
});
